function degToRad(degrees: number) {
  return degrees * (Math.PI / 180);
}

function radToDeg(radians: number) {
  return radians * (180 / Math.PI);
}

export { degToRad, radToDeg };
